import { combineReducers } from '@reduxjs/toolkit';

import configReducer from './entities/config/slice';
import web3ConfigReducer from './entities/web3Config/slice';
import notificationsReducer from './entities/notification/slice';
import marketReducer from './entities/market/slice';
import orderBookReducer from './entities/market/orderbook/slice';
import ordersReducer from './entities/trade/orders/slice';
import walletReducer from './entities/wallet/slice';

export default combineReducers({
  config: configReducer,
  web3Config: web3ConfigReducer,
  notifications: notificationsReducer,
  market: marketReducer,
  orderbook: orderBookReducer,
  wallet: walletReducer,
  trade: combineReducers({
    orders: ordersReducer,
  }),
});
